import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";

const MessageTemplateIcon = () => {
  return <PostAddOutlinedIcon sx={{ fill: "white" }} />;
};

export default MessageTemplateIcon;
